module.exports = __webpack_public_path__ + "static/media/sleepy-post-top.db991981.png";